import { createContext, useContext, useMemo } from "react";
import useSWR from "swr";
import { fetcher } from "@/lib/fetcher";

export type FeatureFlags = Record<string, boolean>;

const DEFAULT_FLAGS: FeatureFlags = {
  "podcast.pro.audio_editor": true,
  "podcast.pro.clip_extractor": true,
  "podcast.pro.auto_build": true,
};

type FeatureFlagsContextValue = {
  flags: FeatureFlags;
  isLoading: boolean;
};

const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({
  flags: DEFAULT_FLAGS,
  isLoading: true,
});

export function FeatureFlagsProvider({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useSWR<FeatureFlags>("/feature-flags", fetcher);
  const value = useMemo(
    () => ({
      flags: data ?? DEFAULT_FLAGS,
      isLoading,
    }),
    [data, isLoading],
  );
  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
